import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import { useExchangeRateRefDateMappingVM } from "presentation/hook/ExchangeRateRefDateMapping/useExchangeRateRefDateMappingVM";
import { useExchangeRateRefDateMappingTracked } from "presentation/store/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingProvider";
import ExchangeRateRefDateMappingTablePanel from "./ExchangeRateRefDateMappingTablePanel";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
const CalendarEventMaintenance: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [exchangeState] = useExchangeRateRefDateMappingTracked();
    const exchangeVM = useExchangeRateRefDateMappingVM();
    const { isBackMaster } = exchangeState;
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit } = anaInfoState;

    useEffect(() => {
        const initialScreen = async () => {
            setIsLoading(true);
            try {
                const results = await Promise.allSettled([
                    exchangeVM.onSearch(),
                    exchangeVM.loadDropdownOption(operatingUnit),
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {

                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then(() => {
            setIsLoading(false)
        }).catch(error => {
            setIsLoading(false)
        });

    }, [isBackMaster, exchangeVM, operatingUnit])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper im-hide-side-form-draggable`}>
            <SliderPanel
                isOpen={false}
                draggable={false}
                leftSectionWidth={"0%"}
                rightSectionWidth={"100%"}
                leftChildren={<ExchangeRateRefDateMappingTablePanel />}
            />
        </div>
    </>
}
export default memo(CalendarEventMaintenance); 
